
export default {
    Totals: {
        template:  0,
        text:      0,
        attribute: 0,
        boolean:   0,
        class:     0,
        checked:   0,
        value:     0
    }
};

export const meta = {
    count: 0
};
